var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 8.82935C9.26587 8.82935 11.1025 7.00185 11.1025 4.74768C11.1025 2.49352 9.26671 0.666016 7.00004 0.666016C4.73337 0.666016 2.89754 2.49352 2.89754 4.74768C2.89754 7.00185 4.73337 8.82935 7.00004 8.82935ZM9.13671 10.5302H4.86337C2.38504 10.5302 0.333374 12.571 0.333374 15.0368C0.333374 15.6319 0.590041 16.1427 1.10254 16.3977C1.87171 16.8227 3.58087 17.3327 7.00004 17.3327C10.4192 17.3327 12.1284 16.8227 12.8975 16.3977C13.1309 16.255 13.324 16.0551 13.4586 15.817C13.5932 15.5789 13.6648 15.3104 13.6667 15.0368C13.6667 12.486 11.6159 10.5302 9.13671 10.5302Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.f8785c2457fa805527c90f86a85fad11.svg";
export { ForwardRef as ReactComponent };